import React, { createContext, useContext, useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const PartnerAuthContext = createContext();

export const usePartnerAuth = () => useContext(PartnerAuthContext);

export const PartnerAuthProvider = ({ children }) => {
  const [partner, setPartner] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('partner_token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      fetchPartner(token);
    } else {
      setLoading(false);
    }
  }, []);

  const fetchPartner = async (authToken) => {
    try {
      const res = await fetch(`${API_URL}/api/partner/me`, {
        headers: { Authorization: `Bearer ${authToken}` },
      });
      if (res.ok) {
        const data = await res.json();
        setPartner(data);
        setToken(authToken);
      } else {
        logout();
      }
    } catch {
      logout();
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    const res = await fetch(`${API_URL}/api/partner/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.detail || 'Erro ao fazer login');
    localStorage.setItem('partner_token', data.token);
    setToken(data.token);
    setPartner(data);
    return data;
  };

  const register = async (formData) => {
    const res = await fetch(`${API_URL}/api/partner/register`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.detail || 'Erro ao registrar');
    localStorage.setItem('partner_token', data.token);
    setToken(data.token);
    setPartner(data);
    return data;
  };

  const logout = () => {
    localStorage.removeItem('partner_token');
    setToken(null);
    setPartner(null);
  };

  return (
    <PartnerAuthContext.Provider value={{ partner, token, loading, login, register, logout, fetchPartner: () => fetchPartner(token) }}>
      {children}
    </PartnerAuthContext.Provider>
  );
};
